import { render, staticRenderFns } from "./ListeProduit.vue?vue&type=template&id=3fbdf1b5"
import script from "./ListeProduit.vue?vue&type=script&lang=js"
export * from "./ListeProduit.vue?vue&type=script&lang=js"
import style0 from "./ListeProduit.vue?vue&type=style&index=0&id=3fbdf1b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports